"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.horizontalPosition = exports.verticalPosition = void 0;

/**
 * @desc
 * Vertical position.
 *
 * @enum
 *
 * @type {{TOP: string, MIDDLE: string, BOTTOM: string}}
 */
var verticalPosition = {
  TOP: 'top',
  MIDDLE: 'middle',
  BOTTOM: 'bottom'
};
/**
 * @desc
 * Vertical position.
 *
 * @enum
 *
 * @type {{LEFT: string, CENTER: string, RIGHT: string}}
 */

exports.verticalPosition = verticalPosition;
var horizontalPosition = {
  LEFT: 'left',
  CENTER: 'center',
  RIGHT: 'right'
};
exports.horizontalPosition = horizontalPosition;
//# sourceMappingURL=constants.js.map